export { default } from "@casino/legacyUi/Img";
